import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import OrderDetailsView from '../components/content/customers/OrderDetailsView';
import OrderHistory from '../components/content/customers/OrderHistory';

const UserOrderHistoryView = () => (
  <Routes>
    <Route element={<OrderHistory />} path="/" />
    <Route element={<OrderDetailsView />} path="/:pkRegCart" />
    <Route element={<Navigate replace to="/orders" />} path="*" />
  </Routes>
);

export default UserOrderHistoryView;
